import { render } from "./ProdutoView.vue?vue&type=template&id=56346400"
import script from "./ProdutoView.vue?vue&type=script&lang=js"
export * from "./ProdutoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__